"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
require("focus-visible/dist/focus-visible");
const provider_1 = require("@chakra-ui/provider");
var system_1 = require("@chakra-ui/system");
Object.defineProperty(exports, "useTheme", { enumerable: true, get: function () { return system_1.useTheme; } });
const Toast_1 = require("./components/Toast");
const theme_1 = __importDefault(require("./theme"));
const extend_theme_1 = require("./theme-tools/extend-theme");
function ThemeProvider(_a) {
    var { children, theme: themeOverrides } = _a, rest = __rest(_a, ["children", "theme"]);
    const theme = themeOverrides ? (0, extend_theme_1.extendTheme)(theme_1.default, themeOverrides) : theme_1.default;
    const ToastContainer = (0, react_1.useMemo)(() => (0, Toast_1.createStandaloneToast)({ theme }).ToastContainer, [theme]);
    return ((0, jsx_runtime_1.jsxs)(provider_1.ChakraProvider, Object.assign({ theme: theme }, rest, { children: [ToastContainer && (0, jsx_runtime_1.jsx)(ToastContainer, {}), children] })));
}
exports.default = ThemeProvider;
